<script>
	import Helper from '../../Classes/Helper';
	import Layout from '../../Stores/Layout';
	import Menu from '../../Stores/Menu';
	import Product from '../../Stores/Product';
	import {onMount} from 'svelte';

	let editor = {};
	let swipe = {};

	function configure() {
		Layout.product();
		Product.setStep(1);
	}

	function mount(event) {
		const onTouchStart = event => {
			editor.removeEventListener('touchstart', onTouchStart);
			swipe.remove()
		};

		editor.addEventListener('touchstart', onTouchStart);
	}

	onMount(mount);
</script>

<style>
	div.zes-editor-info {
		line-height: 1.5em;
	}

	div.zes-editor-info > div:not(.zes-thumbnail) {
		margin-bottom: 2em;
	}

	div.zes-editor-info > div h4 {
		padding-bottom: .5em;
		border-bottom: 1px solid hsl(0deg 0% 90%);
	}

	div.zes-editor-info > div h4 i {
		opacity: .5;
		margin-right: .4em;
	}

	div.zes-thumbnail {
		margin-bottom: 1em;
	}

	div.zes-thumbnail img {
		border-radius: .5em;
		max-height: 18em;
		width: 100%;
		object-fit: contain;
		object-position: center;
		background: var(--zes-1-4);
	}

	div.zes-advantages h4 {
		color: var(--zes-2-1);
	}

	:global(div.zes-editor-info div.zes-advantages ul) {
		color: var(--zes-2-1);
		list-style-image: url(/e2/zonscherm/site/content/shop/configure/media/icons/check-solid.svg);
	}

	div.zes-disadvantages h4 {
		color: var(--zes-4-1);
	}

	:global(div.zes-editor-info div.zes-disadvantages ul) {
		color: var(--zes-4-1);
		list-style-image: url(/e2/zonscherm/site/content/shop/configure/media/icons/xmark-solid.svg);
	}

	div.zes-attributes h4 {
		color: var(--zes-3-1);
	}

	div.zes-images img {
		border-radius: .5em;
		margin-bottom: 1em;
	}

	/* Button */

	div.zes-button {
		font-size: .65em;
		font-weight: 600;
		text-align: center;
		text-transform: uppercase;
		color: #FFF;
		padding: .5em 1.5em;
		border-radius: .35em;
		background: var(--zes-1-2);
		cursor: pointer;
	}

	div.zes-button.zes-success {
		font-size: 1.25em;
		background: var(--zes-2-2);
	}

	div.zes-button i {
		margin-left: .5em;
	}

	div.zes-button.zes-success:hover {
		background: var(--zes-2-1);
	}

	/* Swipe */

	div.zes-swipe {
		position: absolute;
		left: calc(50% - 4em);
		z-index: 20;
		animation: swipeUpDown 3s ease-in-out infinite alternate;
		will-change: opacity;
		display: none;
	}

	div.zes-swipe i {
		font-size: 10em;
		color: #FFF;
		text-shadow: 0 0 .5rem hsla(0, 0%, 0%, .5);
	}

	@keyframes swipeUpDown {
		0% { transform: translateY(0); }
		50% { transform: translateY(3em); }
		100% { transform: translateY(0); }
	}

	/* Content */

	:global(div.zes-editor-info div.zes-attributes ul) {
		list-style-image: url(/e2/zonscherm/site/content/shop/configure/media/icons/circle-small-solid.svg);
	}

	:global(div.zes-editor-info li) {
		font-weight: 500;
		padding-top: .25em;
		padding-bottom: .25em;
		padding-left: .75em;
	}

	:global(div.zes-editor-info p),
	:global(div.zes-editor-info h3),
	:global(div.zes-editor-info h4) {
		margin: 1em 0;
	}

	:global(div.zes-editor-info h4) {
		color: var(--zes-1-2);
	}

	:global(div.zes-editor-info a) {
		font-weight: 500;
		color: var(--zes-1-2);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-swipe {
			display: block;
		}
	}
</style>

<div bind:this="{editor}" class="zes-editor-info">
	{#if Helper.is($Product.id)}
		<div bind:this="{swipe}" class="zes-swipe">
			<i class="fa-duotone fa-arrows-up-down fa-rotate-180"></i>
		</div>
		{#if $Product.thumbnail}
			<div class="zes-thumbnail">
				<img src="{$Product.thumbnail}"/>
			</div>
		{/if}
		{#if $Product.description}
			<div class="zes-start">
				<div class="zes-button zes-success" on:click="{event => configure()}">
					Direct Configureren <i class="fa-solid fa-circle-arrow-right"></i>
				</div>
			</div>
			<div class="zes-description">
				<h4><i class="fa-regular fa-circle-info"></i> Beschrijving</h4>
				{@html $Product.description}
			</div>
		{/if}
		{#if $Product.advantages}
			<div class="zes-advantages">
				<h4><i class="fa-regular fa-circle-check"></i> Voordelen</h4>
				{@html $Product.advantages}
			</div>
		{/if}
		{#if $Product.disadvantages}
			<div class="zes-disadvantages">
				<h4><i class="fa-regular fa-circle-minus"></i> Nadelen</h4>
				{@html $Product.disadvantages}
			</div>
		{/if}
		{#if $Product.attributes}
			<div class="zes-attributes">
				<h4><i class="fa-regular fa-circle-ellipsis-vertical"></i> Eigenschappen</h4>
				{@html $Product.attributes}
			</div>
		{/if}
		<div class="zes-images">
			<h4><i class="fa-regular fa-circle-camera"></i> Afbeeldingen</h4>
			{#each [1, 2, 3, 4] as current}
				{#if $Product[`image_${current}`]}
					<img src="{$Product[`image_${current}`]}"/>
				{/if}
			{/each}
		</div>
	{/if}
</div>